/* BECK 777 MOBILE v1.0-R · M2 (r2) · RC2-polish · Line rollout: guarded multi-color support.
   ≤767px only. Single-color products: color code no-ops (no [data-mh-cswatch] present). */
(function () {
  'use strict';
  if (!window.matchMedia('(max-width: 767px)').matches) return;
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SCROLL_BEHAVIOR = REDUCED ? 'auto' : 'smooth';

  var mh = document.querySelector('[data-mh]');
  var sticky = document.querySelector('[data-m-sticky]');
  var chosen = false;
  var lastSize = { v: '' };

  /* — size selector state — */
  if (mh) {
    var price = mh.querySelector('[data-mh-price]');
    var idInput = mh.querySelector('[data-mh-id]');
    var label = mh.querySelector('[data-mh-sizelabel]');
    var sPrice = sticky ? sticky.querySelector('[data-m-price]') : null;
    var sCta = sticky ? sticky.querySelector('[data-m-cta]') : null;
    var atcLabel = sticky ? (sticky.getAttribute('data-atc-label') || 'Add to Cart') : 'Add to Cart';
    var chips = Array.prototype.slice.call(mh.querySelectorAll('[data-mh-chip]'));
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.disabled) return;
        chips.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
        chip.classList.add('is-selected');
        chip.setAttribute('aria-checked', 'true');
        lastSize.v = chip.getAttribute('data-size') || chip.textContent.trim();
        var vid = chip.getAttribute('data-variant-id');
        var p = chip.getAttribute('data-price');
        if (idInput && vid) idInput.value = vid;
        if (price && p) price.textContent = p;
        if (sPrice && p) sPrice.textContent = p;
        if (label) label.textContent = 'Size — ' + chip.textContent.trim();
        chosen = true;
        if (sCta) { sCta.textContent = atcLabel; sCta.setAttribute('aria-label', atcLabel); sCta.setAttribute('data-state', 'atc'); }
        try { var u = new URL(location.href); u.searchParams.set('variant', vid); history.replaceState({}, '', u); } catch (e) { /* no-op */ }
      });
    });

    /* — multi-color (guarded: only when selectable swatches exist) — */
    var cswatches = Array.prototype.slice.call(mh.querySelectorAll('[data-mh-cswatch]'));
    if (cswatches.length) {
      var groups = Array.prototype.slice.call(mh.querySelectorAll('[data-color-group]'));
      var clabel = mh.querySelector('[data-mh-colorlabel]');
      cswatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          var val = sw.getAttribute('data-color');
          cswatches.forEach(function (s) { var on = s === sw; s.classList.toggle('is-selected', on); s.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          groups.forEach(function (g) { g.hidden = g.getAttribute('data-color-group') !== val; });
          if (clabel) clabel.textContent = val;
          var g = null;
          for (var i = 0; i < groups.length; i++) { if (!groups[i].hidden) { g = groups[i]; break; } }
          if (!g) return;
          var target = lastSize.v ? g.querySelector('[data-mh-chip][data-size="' + lastSize.v + '"]:not([disabled])') : null;
          if (!target) target = g.querySelector('[data-mh-chip].is-selected:not([disabled])') || g.querySelector('[data-mh-chip]:not([disabled])');
          if (target) target.click();
        });
      });
    }
  }

  /* — sticky bar — */
  if (sticky && mh && 'IntersectionObserver' in window) {
    var heroCta = mh.querySelector('[data-mh-cta]');
    if (heroCta) {
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting;
        sticky.classList.toggle('is-on', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        var b = sticky.querySelector('[data-m-cta]');
        if (b) b.tabIndex = past ? 0 : -1;
      }, { rootMargin: '0px 0px 100000px 0px', threshold: 0 }).observe(heroCta);
    }
    var ctaBtn = sticky.querySelector('[data-m-cta]');
    if (ctaBtn) ctaBtn.addEventListener('click', function () {
      if (!chosen) {
        var grid = document.getElementById('beck777-m-size');
        if (grid) grid.scrollIntoView({ behavior: SCROLL_BEHAVIOR, block: 'center' });
      } else {
        var form = mh.querySelector('.beck777-mh__form');
        if (form) { if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); } }
      }
    });
  }

  /* — gallery: counter + cue — */
  var track = document.querySelector('[data-m-gallery]');
  if (track) {
    var cur = document.querySelector('[data-m-count]');
    var tot = document.querySelector('[data-m-total]');
    var cue = document.querySelector('[data-m-cue]');
    var n = track.children.length;
    if (tot) tot.textContent = n;
    var ticking = false;
    var update = function () {
      if (cur && track.clientWidth > 0) {
        var idx = Math.min(n, Math.max(1, Math.round(track.scrollLeft / track.clientWidth) + 1));
        cur.textContent = idx;
      }
      ticking = false;
    };
    track.addEventListener('scroll', function () {
      if (cue) { cue.classList.add('is-off'); cue = null; }
      if (ticking) return; ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', update, { passive: true });
  }
})();
